import React from 'react';
import './DuelSimulator.css';

const zoneLabels = {
  monster: ['MZ1', 'MZ2', 'MZ3', 'MZ4', 'MZ5'],
  spellTrap: ['STZ1', 'STZ2', 'STZ3', 'STZ4', 'STZ5'],
  extraMonster: ['EXMZ1', 'EXMZ2'],
};

const DuelSimulator = () => {
  return (
    <div className="duel-simulator">
      {/* Top Half: Opponent Zones */}
      <div className="sim-field-row">
        <div className="sim-side-column">Opp Extra</div>
        <div className="sim-side-column">Opp FZ</div>
        <div className="sim-side-column">My BZ</div>
        <div className="sim-side-column">My GYZ</div>
        <div className="sim-side-column">My Deck</div>
      </div>

      <div className="sim-field-row">
        <div className="sim-column">Opp STZ1</div>
        <div className="sim-column">Opp MZ1</div>
        <div className="sim-column">Empty</div>
        <div className="sim-column">My MZ5</div>
        <div className="sim-column">My STZ5</div>
      </div>

      <div className="sim-field-row">
        <div className="sim-column">Opp STZ2</div>
        <div className="sim-column">Opp MZ2</div>
        <div className="sim-column">EXMZ2</div>
        <div className="sim-column">My MZ4</div>
        <div className="sim-column">My STZ4</div>
      </div>

      <div className="sim-field-row">
        <div className="sim-column">Opp STZ3</div>
        <div className="sim-column">Opp MZ3</div>
        <div className="sim-column">Empty</div>
        <div className="sim-column">My MZ3</div>
        <div className="sim-column">My STZ3</div>
      </div>

      <div className="sim-field-row">
        <div className="sim-column">Opp STZ4</div>
        <div className="sim-column">Opp MZ4</div>
        <div className="sim-column">EXMZ1</div>
        <div className="sim-column">My MZ2</div>
        <div className="sim-column">My STZ2</div>
      </div>

      <div className="sim-field-row">
        <div className="sim-column">Opp STZ5</div>
        <div className="sim-column">Opp MZ5</div>
        <div className="sim-column">Empty</div>
        <div className="sim-column">My MZ1</div>
        <div className="sim-column">My STZ1</div>
      </div>

      <div className="sim-field-row">
        <div className="sim-side-column">Opp Deck</div>
        <div className="sim-side-column">Opp GYZ</div>
        <div className="sim-side-column">Opp BZ</div>
        <div className="sim-side-column">My FZ</div>
        <div className="sim-side-column">My Extra</div>
      </div>

      <div className="sim-hand-row">My Hand</div>
    </div>
  );
};

export default DuelSimulator;
